import React from "react";
import { titleContent } from "../../Style";
import { useNavigate } from "react-router-dom";

export default function AgenticAI() {
  const navigate = useNavigate();
  return (
    <div className=" w-full bg-[#eef3e8] flex items-center justify-center p-6 mobile:p-2">
      <div className=" w-full flex flex-col gap-4">
        {/* Header */}
        <div className="flex flex-col gap-2">
          <h1 className={`${titleContent} font-bold text-green-900 `}>
            Agentic AI: Beyond RPA
          </h1>
          <p className="text-[#41493E] max-w-2xl text-lg leading-7">
            While robots follow steps, agents make decisions. Our Agentic AI
            platform learns enterprise context to navigate ambiguity and execute
            complex goal-oriented tasks.
          </p>
        </div>

        <div className="flex gap-6 mobile:flex-col ipadMin:gap-3">
          {/* Left Card */}
          <div className="md:col-span-2 bg-white rounded-3xl p-6 mobile:p-2 ipadMin:p-2 shadow-sm hover:shadow-2xl hover:scale-[1.01] transition-all duration-500 border border-transparent hover:border-green-100/50 group">
            <div className="flex justify-between items-start mb-6">
              <div className="bg-green-100 p-3 rounded-xl">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="29"
                  height="30"
                  viewBox="0 0 29 30"
                  fill="none"
                >
                  <path
                    d="M12 19.5H15L15.225 17.625C15.425 17.55 15.6062 17.4625 15.7688 17.3625C15.9313 17.2625 16.075 17.15 16.2 17.025L17.925 17.775L19.425 15.225L17.925 14.1C17.975 13.9 18 13.7 18 13.5C18 13.3 17.975 13.1 17.925 12.9L19.425 11.775L17.925 9.225L16.2 9.975C16.075 9.85 15.9313 9.7375 15.7688 9.6375C15.6062 9.5375 15.425 9.45 15.225 9.375L15 7.5H12L11.775 9.375C11.575 9.45 11.3938 9.5375 11.2312 9.6375C11.0687 9.7375 10.925 9.85 10.8 9.975L9.075 9.225L7.575 11.775L9.075 12.9C9.025 13.1 9 13.3 9 13.5C9 13.7 9.025 13.9 9.075 14.1L7.575 15.225L9.075 17.775L10.8 17.025C10.925 17.15 11.0687 17.2625 11.2312 17.3625C11.3938 17.4625 11.575 17.55 11.775 17.625L12 19.5ZM13.5 15.75C12.875 15.75 12.3438 15.5312 11.9062 15.0938C11.4688 14.6562 11.25 14.125 11.25 13.5C11.25 12.875 11.4688 12.3438 11.9062 11.9062C12.3438 11.4688 12.875 11.25 13.5 11.25C14.125 11.25 14.6562 11.4688 15.0938 11.9062C15.5312 12.3438 15.75 12.875 15.75 13.5C15.75 14.125 15.5312 14.6562 15.0938 15.0938C14.6562 15.5312 14.125 15.75 13.5 15.75ZM4.5 30V23.55C3.075 22.25 1.96875 20.7312 1.18125 18.9937C0.39375 17.2563 0 15.425 0 13.5C0 9.75 1.3125 6.5625 3.9375 3.9375C6.5625 1.3125 9.75 0 13.5 0C16.625 0 19.3937 0.91875 21.8062 2.75625C24.2188 4.59375 25.7875 6.9875 26.5125 9.9375L28.4625 17.625C28.5875 18.1 28.5 18.5312 28.2 18.9188C27.9 19.3063 27.5 19.5 27 19.5H24V24C24 24.825 23.7062 25.5312 23.1187 26.1187C22.5312 26.7062 21.825 27 21 27H18V30H4.5Z"
                    fill="#00450D"
                  />
                </svg>
              </div>
              <span className="text-xs tracking-widest text-[#686000] font-semibold">
                AUTONOMOUS REASONING
              </span>
            </div>

            <h2 className="text-2xl font-semibold text-[#00450D] mb-4">
              Dynamic Decision Engines
            </h2>

            <p className="text-gray-700 mb-6 leading-relaxed">
              Agents that don't just process data—they interpret intent. Capable
              of handling exceptions, negotiating outcomes, and optimizing
              workflows in real-time without human intervention.
            </p>

            <div className="flex gap-4 flex-wrap">
              <div className="flex items-center gap-2 bg-[#F5FCED] px-4 py-2 rounded-full text-sm text-[#171D14]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="21"
                  viewBox="0 0 22 21"
                  fill="none"
                >
                  <path
                    d="M7.6 21L5.7 17.8L2.1 17L2.45 13.3L0 10.5L2.45 7.7L2.1 4L5.7 3.2L7.6 0L11 1.45L14.4 0L16.3 3.2L19.9 4L19.55 7.7L22 10.5L19.55 13.3L19.9 17L16.3 17.8L14.4 21L11 19.55L7.6 21ZM8.45 18.45L11 17.35L13.6 18.45L15 16.05L17.75 15.4L17.5 12.6L19.35 10.5L17.5 8.35L17.75 5.55L15 4.95L13.55 2.55L11 3.65L8.4 2.55L7 4.95L4.25 5.55L4.5 8.35L2.65 10.5L4.5 12.6L4.25 15.45L7 16.05L8.45 18.45ZM9.95 14.05L15.6 8.4L14.2 6.95L9.95 11.2L7.8 9.1L6.4 10.5L9.95 14.05Z"
                    fill="#00450D"
                  />
                </svg>{" "}
                Context Awareness
              </div>
              <div className="flex items-center gap-2 bg-[#F5FCED] px-4 py-2 rounded-full text-sm text-[#171D14]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="20"
                  viewBox="0 0 16 20"
                  fill="none"
                >
                  <path
                    d="M6.55 16.2L11.725 10H7.725L8.45 4.325L3.825 11H7.3L6.55 16.2ZM4 20L5 13H0L9 0H11L10 8H16L6 20H4Z"
                    fill="#00450D"
                  />
                </svg>{" "}
                Real-time Adaptation
              </div>
            </div>
          </div>

          {/* Right Card */}
          <div className="bg-[#1B5E20] text-white rounded-3xl p-6  mobile:p-2 ipadMin:p-2 flex flex-col justify-between relative overflow-hidden hover:shadow-2xl hover:scale-[1.01] transition-all duration-500 group">
            <div>
              <div className="mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="46"
                  viewBox="0 0 48 46"
                  fill="none"
                >
                  <path
                    d="M12 46C10.3333 46 8.91667 45.4167 7.75 44.25C6.58333 43.0833 6 41.6667 6 40C6 38.3333 6.58333 36.9167 7.75 35.75C8.91667 34.5833 10.3333 34 12 34C12.4667 34 12.9 34.05 13.3 34.15C13.7 34.25 14.0833 34.3833 14.45 34.55L17.3 31C16.3667 29.9667 15.7167 28.8 15.35 27.5C14.9833 26.2 14.9 24.9 15.1 23.6L11.05 22.25C10.4833 23.0833 9.76667 23.75 8.9 24.25C8.03333 24.75 7.06667 25 6 25C4.33333 25 2.91667 24.4167 1.75 23.25C0.583333 22.0833 0 20.6667 0 19C0 17.3333 0.583333 15.9167 1.75 14.75C2.91667 13.5833 4.33333 13 6 13C7.66667 13 9.08333 13.5833 10.25 14.75C11.4167 15.9167 12 17.3333 12 19C12 19.0667 12 19.1333 12 19.2C12 19.2667 12 19.3333 12 19.4L16.05 20.8C16.7167 19.6 17.6083 18.5833 18.725 17.75C19.8417 16.9167 21.1 16.3833 22.5 16.15V11.8C21.2 11.4333 20.125 10.725 19.275 9.675C18.425 8.625 18 7.4 18 6C18 4.33333 18.5833 2.91667 19.75 1.75C20.9167 0.583333 22.3333 0 24 0C25.6667 0 27.0833 0.583333 28.25 1.75C29.4167 2.91667 30 4.33333 30 6C30 7.4 29.5667 8.625 28.7 9.675C27.8333 10.725 26.7667 11.4333 25.5 11.8V16.15C26.9 16.3833 28.1583 16.9167 29.275 17.75C30.3917 18.5833 31.2833 19.6 31.95 20.8L36 19.4C36 19.3333 36 19.2667 36 19.2C36 19.1333 36 19.0667 36 19C36 17.3333 36.5833 15.9167 37.75 14.75C38.9167 13.5833 40.3333 13 42 13C43.6667 13 45.0833 13.5833 46.25 14.75C47.4167 15.9167 48 17.3333 48 19C48 20.6667 47.4167 22.0833 46.25 23.25C45.0833 24.4167 43.6667 25 42 25C40.9333 25 39.9583 24.75 39.075 24.25C38.1917 23.75 37.4833 23.0833 36.95 22.25L32.9 23.6C33.1 24.9 33.0167 26.1917 32.65 27.475C32.2833 28.7583 31.6333 29.9333 30.7 31L33.55 34.5C33.9167 34.3333 34.3 34.2083 34.7 34.125C35.1 34.0417 35.5333 34 36 34C37.6667 34 39.0833 34.5833 40.25 35.75C41.4167 36.9167 42 38.3333 42 40C42 41.6667 41.4167 43.0833 40.25 44.25C39.0833 45.4167 37.6667 46 36 46C34.3333 46 32.9167 45.4167 31.75 44.25C30.5833 43.0833 30 41.6667 30 40C30 39.3333 30.1083 38.6917 30.325 38.075C30.5417 37.4583 30.8333 36.9 31.2 36.4L28.35 32.85C26.9833 33.6167 25.525 34 23.975 34C22.425 34 20.9667 33.6167 19.6 32.85L16.8 36.4C17.1667 36.9 17.4583 37.4583 17.675 38.075C17.8917 38.6917 18 39.3333 18 40C18 41.6667 17.4167 43.0833 16.25 44.25C15.0833 45.4167 13.6667 46 12 46ZM6 21C6.56667 21 7.04167 20.8083 7.425 20.425C7.80833 20.0417 8 19.5667 8 19C8 18.4333 7.80833 17.9583 7.425 17.575C7.04167 17.1917 6.56667 17 6 17C5.43333 17 4.95833 17.1917 4.575 17.575C4.19167 17.9583 4 18.4333 4 19C4 19.5667 4.19167 20.0417 4.575 20.425C4.95833 20.8083 5.43333 21 6 21ZM12 42C12.5667 42 13.0417 41.8083 13.425 41.425C13.8083 41.0417 14 40.5667 14 40C14 39.4333 13.8083 38.9583 13.425 38.575C13.0417 38.1917 12.5667 38 12 38C11.4333 38 10.9583 38.1917 10.575 38.575C10.1917 38.9583 10 39.4333 10 40C10 40.5667 10.1917 41.0417 10.575 41.425C10.9583 41.8083 11.4333 42 12 42ZM24 8C24.5667 8 25.0417 7.80833 25.425 7.425C25.8083 7.04167 26 6.56667 26 6C26 5.43333 25.8083 4.95833 25.425 4.575C25.0417 4.19167 24.5667 4 24 4C23.4333 4 22.9583 4.19167 22.575 4.575C22.1917 4.95833 22 5.43333 22 6C22 6.56667 22.1917 7.04167 22.575 7.425C22.9583 7.80833 23.4333 8 24 8ZM24 30C25.4 30 26.5833 29.5167 27.55 28.55C28.5167 27.5833 29 26.4 29 25C29 23.6 28.5167 22.4167 27.55 21.45C26.5833 20.4833 25.4 20 24 20C22.6 20 21.4167 20.4833 20.45 21.45C19.4833 22.4167 19 23.6 19 25C19 26.4 19.4833 27.5833 20.45 28.55C21.4167 29.5167 22.6 30 24 30ZM36 42C36.5667 42 37.0417 41.8083 37.425 41.425C37.8083 41.0417 38 40.5667 38 40C38 39.4333 37.8083 38.9583 37.425 38.575C37.0417 38.1917 36.5667 38 36 38C35.4333 38 34.9583 38.1917 34.575 38.575C34.1917 38.9583 34 39.4333 34 40C34 40.5667 34.1917 41.0417 34.575 41.425C34.9583 41.8083 35.4333 42 36 42ZM42 21C42.5667 21 43.0417 20.8083 43.425 20.425C43.8083 20.0417 44 19.5667 44 19C44 18.4333 43.8083 17.9583 43.425 17.575C43.0417 17.1917 42.5667 17 42 17C41.4333 17 40.9583 17.1917 40.575 17.575C40.1917 17.9583 40 18.4333 40 19C40 19.5667 40.1917 20.0417 40.575 20.425C40.9583 20.8083 41.4333 21 42 21Z"
                    fill="#ACF4A4"
                  />
                </svg>
              </div>

              <h3 className="text-2xl text-[#90D689] font-semibold mb-3">
                Multi-Agent Swarms
              </h3>

              <p className="text-[#90D689] text-sm leading-relaxed">
                Deploy clusters of specialized agents that communicate and
                collaborate to solve multi-stage organizational problems.
              </p>
            </div>

            <button
              onClick={() => navigate("/swarm-ai")}
              className="mt-6 flex items-center gap-2 text-[#F6E550] font-medium group-hover:translate-x-1 transition-transform duration-300"
            >
              View Swarm Tech{" "}
              <svg
                className="group-hover:translate-x-1 transition-transform duration-300"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M12.175 9H0V7H12.175L6.575 1.4L8 0L16 8L8 16L6.575 14.6L12.175 9Z"
                  fill="#F6E550"
                />
              </svg>
            </button>

            {/* Decorative pixels */}
            <div className="absolute bottom-0 right-0 opacity-20">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="96"
                height="136"
                viewBox="0 0 96 136"
                fill="none"
              >
                <path
                  d="M0 176V128H20V112H0V64H20V48H0V0H56V48H36V64H56V80H80V64H136V112H80V96H56V112H36V128H56V176H0ZM16 160H40V144H16V160ZM16 96H40V80H16V96ZM96 96H120V80H96V96ZM16 32H40V16H16V32Z"
                  fill="#90D689"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
